var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlusBlack = function SvgPlusBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8333 11.6663C20.8333 11.2061 20.4602 10.833 19.9999 10.833C19.5397 10.833 19.1666 11.2061 19.1666 11.6663V19.1664H11.6667C11.2065 19.1664 10.8334 19.5395 10.8334 19.9997C10.8334 20.4599 11.2065 20.833 11.6667 20.833H19.1666V28.333C19.1666 28.7932 19.5397 29.1663 19.9999 29.1663C20.4602 29.1663 20.8333 28.7932 20.8333 28.333V20.833H28.3334C28.7936 20.833 29.1667 20.4599 29.1667 19.9997C29.1667 19.5395 28.7936 19.1664 28.3334 19.1664H20.8333V11.6663Z",
    fill: "#232528"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus-black.1dfd1233.svg";
export { ForwardRef as ReactComponent };